<template>
  <div class="no-network">
    <MaterialIcon :size="40">wifi_off</MaterialIcon>
    <p>抱歉，當前無法偵測到網路連線</p>
    <p>請檢查您的網路連線</p>

    <footer class="brand-footer">
      <img :src="gimmatekLogo" :srcset="`${gimmatekLogo} 1x, ${gimmatekLogo2x} 2x`" alt="GIMMATEK">
    </footer>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import MaterialIcon from '@/components/MaterialIcon.vue'
import gimmatekLogo from '@/assets/header/logo-gimmatek.png'
import gimmatekLogo2x from '@/assets/header/logo-gimmatek-2x.png'

export default defineComponent({
  name: 'NoNetwork',
  components: { MaterialIcon },
  setup (props) {
    return { gimmatekLogo, gimmatekLogo2x }
  },
})
</script>

<style lang="postcss" scoped>
.no-network {
    @apply h-full w-full relative;
    @apply p-[20px];
    @apply flex flex-col items-center justify-center;
}

.brand-footer {
    @apply absolute bottom-[20px] left-0 right-0 m-auto;
    @apply flex flex-col justify-center items-center justify-center;
}
</style>
